import template from './assignments.html';
import controller from './assignments.controller';
import metaData from '../../models/metaData.js';

let assignmentsComponent = () => {
  return {
    restrict: 'E',
    require: '^^entitler',
    scope: {},
    template,
    controller,
    controllerAs: 'vm',
    link: ($scope, $elem, $attrs, entitler) => {
      setDefaults($scope, entitler);
    }
  };
};

function setDefaults($scope, entitler) {
  $scope.vm.metaData = {};
  angular.copy(metaData, $scope.vm.metaData);
  $scope.vm.entitler = entitler;
  $scope.vm.metaData.entitler.dataSet = entitler;
  $scope.vm.metaData.entitler.selectedValues = $scope.vm.selectedValues;
  $scope.vm.metaData.entitler.changedValues = $scope.vm.changedValues;
  $scope.vm.metaData.entitler.search.value = $scope.vm.searchValue;
  $scope.vm.metaData.entitler.disabledValues = $scope.vm.disabledValues;
  $scope.vm.metaData.entitler.schoolList = $scope.vm.schoolList;
  $scope.vm.metaData.entitler.rowIds = [];
  $scope.vm.metaData.entitler.schoolMappingCreated = {};
  $scope.vm.metaData.entitler.schoolMappingDeleted = {};
}

export
default assignmentsComponent;



// WEBPACK FOOTER //
// ./app/components/assignments/assignments.component.js